<template>
    <div
        class="flex flex-row cursor-pointer bg-gradient-light-blue-400 p-4 md:p-6 space-x-2 items-center rounded-2xl"
        @click="clicked"
    >
        <div class="w-full">
            <p>{{ text }}</p>
            <Btn
                color="blue-600"
                variant="text"
                :label="btnText"
                compact
                right-icon="arrow-right"
            />
        </div>
        <div class="w-[92px]">
            <div
                data-testid="sidebar-logo-studydrive"
                class="logo logo-studydrive-premium logo min-w-[92px] min-h-[92px] w-[92px] h-[92px]"
                alt="Logo"
            />
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { trackEvent } from '@/modules/tracking';

export default defineComponent({
    name: 'PremiumAd',
    props: {
        /**
         * Ad text
         */
        text: {
            type: String,
            default: 'Download documents with Premium.',
        },
        /**
         * Ad button text
         */
        btnText: {
            type: String,
            default: 'Go Premium',
        },
        /**
         * Tracking Category
         */
        trackingCategory: {
            type: String,
            default: '',
        },
        /**
         * Impression tracking Name
         */
        impressionTrackingName: {
            type: String,
            default: '',
        },
        /**
         * Click tracking Name
         */
        clickTrackingName: {
            type: String,
            default: '',
        },
    },
    emits: ['premium-ad-clicked'],
    computed: {},
    mounted() {
        this.impression();
    },
    methods: {
        impression() {
            if (this.trackingCategory && this.impressionTrackingName) {
                trackEvent(this.trackingCategory, this.impressionTrackingName);
            }
        },
        clicked() {
            if (this.trackingCategory && this.clickTrackingName) {
                trackEvent(this.trackingCategory, this.clickTrackingName);
            }

            this.$emit('premium-ad-clicked');
        },
    },
});
</script>

<style lang="scss" scoped></style>
